import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 1,
    color: '#621132',
    title: "Principio 16. - Realizar Actividades de Supervisión.",
    items: [
         // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },

      // "Instancias de Supervisión.",
      // "Metodología para Autoevaluación del Sistema de Control Interno Institucional",
      // "Informe Anual del Estado que Guarda el Sistema de Control Interno.",
      // "Evaluación Externa (SCII)."
    ]
  },
  {
    id: 2,
    color: '#9e2348',
    title: "Principio 17. - Implementación de acciones de mejora o para corregir deficiencias detectadas al Control Interno.",
    items: [
             // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },

      // "Programa de Trabajo de Control Interno (PTCI)."
    ]
  }
];

const Supervision = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Supervisión
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Son las actividades establecidas y operadas por las unidades específicas que él o la Titular ha designado, con la finalidad de mejorar de manera continua al Control Interno mediante una vigilancia y evaluación periódicas a su eficacia, eficiencia y economía. La supervisión es responsabilidad de la Administración en cada uno de los procesos que realiza, y se apoya, por lo general, en unidades específicas para llevarla a cabo. Las Entidades Fiscalizadoras Superiores y otros revisores externos proporcionan una supervisión adicional cuando revisan el Control Interno de la institución, ya sea a nivel institución, división, unidad administrativa o función. La supervisión contribuye a la optimización permanente del Control Interno y, por lo tanto, a la calidad en el desempeño de las operaciones, la salvaguarda de los recursos públicos, la prevención de la corrupción, la oportuna resolución de los hallazgos de auditoria y de otras revisiones, así como a la idoneidad y suficiencia de los controles implementados.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                              <li key={idx} className="mb-2">
                                <a href="#" style={{ color: '#621132' }}>{item}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Supervision;
